import DatatablesController from '../../../../datatables_controller';

export default class extends DatatablesController {
  datatableColumns() {
    return [
      {
        field: 'index',
        title: 'No',
        sortable: false,
        width: 25,
        type: 'number',
        selector: false,
        textAlign: 'left',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.index}</span>`;
        }
      },
      {
        field: 'user_name',
        title: 'Nama',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.user_name}</span>`;
        }
      },
      {
        field: 'user_username',
        title: 'Username',
        overflow: 'visible',
        autoHide: false,
        width: 150,
        template: function(data) {
          return `<span class="text-muted">@${data.user_username}</span>`;
        }
      },
      {
        field: 'earned_at',
        title: 'Diperoleh',
        overflow: 'visible',
        autoHide: false,
        width: 120,
        template: function(data) {
          return `<span>${data.earned_at || '-'}</span>`;
        }
      },
      {
        field: 'Actions',
        title: 'Aksi',
        sortable: false,
        width: 100,
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `
            <a class="btn btn-sm btn-danger btn-xs" href="${data.revoke_path}"
               data-method="delete" data-confirm="Cabut badge dari user ini?">Cabut</a>
          `;
        }
      }
    ];
  }
}
